import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { withStyles } from '@material-ui/core'

import Markdown from 'components/ui/Markdown'
import Loading from 'components/ui/Loading'

import { getPrivacyPolicy } from 'api/privacyPolicy'

class PrivacyPolicy extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      privacyPolicy: ''
    }
  }

  componentDidMount() {
    this.fetchPrivacyPolicy()
  }

  fetchPrivacyPolicy = async () => {
    try {
      const params = {
        l: navigator.language
      }

      const { data } = await getPrivacyPolicy(params)

      this.setState({ privacyPolicy: data.privacy_policy.description })
    } catch (error) {
      console.log(error)
    }

    this.setState({ loading: false })
  }

  render() {
    const { classes } = this.props
    const { loading, privacyPolicy } = this.state

    return (
      <div className={classes.PrivacyPolicy}>
        <div className={classes.PrivacyPolicy_container}>
          {
            loading
            ? <Loading />
            : <Markdown markdown={privacyPolicy} />
          }          
        </div>
      </div>
    )
  }
}

const styles = () => ({
  PrivacyPolicy_wrapper: {
    maxHeight: '100vh',
    margin: '50px 30px'
  },
  PrivacyPolicy_container: {
    overflowY: 'auto',
    maxHeight: 'calc(100vh - 100px)',
    marginTop: 16
  }
})

export default withTranslation()(withStyles(styles)(PrivacyPolicy))
